<template>
	<nut-dialog
		teleport="body"
		title="密码重置"
		:visible="modelValue"
		@ok="handleOK"
		@cancel="handleClose"
	>
		<nut-form class="form" :model-value="formData" ref="formRef">
			<nut-form-item
				label="手机号"
				prop="mobile"
				required
				:rules="[
					{ required: true, message: '请输入手机号' },
					{
						regex: mobileReg,
						message: '请输入正确的手机号',
					},
				]"
			>
				<nut-input
					class="input"
					v-model="formData.mobile"
					placeholder="请输入注册时的手机号"
					type="tel"
				>
				</nut-input>
			</nut-form-item>
			<nut-form-item
				label="验证码"
				prop="code"
				required
				:rules="[{ required: true, message: '请输入验证码' }]"
			>
				<nut-input
					class="input"
					v-model="formData.code"
					placeholder="请输入验证码"
					type="text"
				>
					<template #button>
						<nut-button
							size="small"
							type="primary"
							@click="handleSendCode"
							:disabled="hasSendMsg"
						>
							{{ hasSendMsg ? `${sendTime} s` : '获取验证码' }}
						</nut-button>
					</template>
				</nut-input>
			</nut-form-item>
		</nut-form>
	</nut-dialog>
</template>

<script>
import { reactive, ref } from 'vue';
import useSendMessage from '@/hooks/useSendMessage';
import { mobileReg } from '@/utils/util.regexp';
import { loginApi } from '@/apis';
import { getStorage } from '@/utils/util';
import { UUID } from '@/constants';
import { Toast } from '@nutui/nutui';

export default {
	name: 'ForgetPassword',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const formData = reactive({
			mobile: '',
			code: '',
		});
		const formRef = ref(null);
		const { hasSendMsg, sendTime, handleSendMsg } = useSendMessage();

		const resetForm = () => {
			formRef.value.reset();
			formData.mobile = formData.code = '';
		};
		const handleClose = () => {
			resetForm();
			emit('update:modelValue', false);
		};
		const handleOK = () => {
			formRef.value.validate().then(async ({ valid }) => {
				if (valid) {
					const { mobile, code } = formData;
					await loginApi.reset_password({
						uuid: getStorage(UUID),
						phone: mobile,
						code,
					});
					Toast.success(
						'密码已重置，稍后会将新密码以短信形式发送，请留意',
						{
							onClose() {
								emit('update:modelValue', false);
							},
						}
					);
				}
			});
		};
		const handleSendCode = () => {
			formRef.value.validate('mobile').then(({ valid, errors }) => {
				if (valid) {
					handleSendMsg({
						uuid: getStorage(UUID),
						phone: formData.mobile,
						msg_type: 'reset_password',
					});
				} else {
					console.log('error', errors);
				}
			});
		};
		return {
			formData,
			formRef,
			mobileReg,
			sendTime,
			hasSendMsg,

			handleClose,
			handleOK,
			handleSendCode,
		};
	},
};
</script>

<style lang="scss" scoped>
.form {
	:deep(.nut-form-item__label),
	:deep(.nut-form-item__label.required::before) {
		display: none !important;
	}
	:deep(.nut-cell) {
		&:last-child::after {
			border-bottom: 2px solid #f5f6f7 !important;
		}
	}
	.input {
		padding: 0;
		border-bottom: none;
		line-height: 28px;
	}
}
</style>
